// extracted by mini-css-extract-plugin
module.exports = {"container":"custom_toast_container-module__container--3eRSD"};